import { ISearchUserData } from '@/lib/interface';
import DataTable from './DataTable';

export interface IHasUser {
  user: ISearchUserData;
}

export default DataTable;
